<app-spinner [active]="loading"></app-spinner>
<div
  [ngStyle]="{ background: 'url(assets/images/MADB-BANNER-7.jpg)' }"
  class="content-header"
>
  <h2 class="header-title">Master Action</h2>
  <h3 class="header-subtitle">{{ mode === 'Update' ? 'Update' : 'Create New' }} Incident</h3>
</div>
<app-modal
  [active]="modal.active"
  [data]="modal.data"
  (confirmed)="modalConfirmed($event)"
  (denied)="modalDenied($event)"
>
</app-modal>
<div class="form">
  <h1 class="main-title">
    {{ mode === 'Update' ? 'Update' : 'Create New' }} Incident
  </h1>
  <div class="section-container" *ngFor="let section of sections">
    <div class="title">
      <span>{{ section.title }}</span>
    </div>
    <div class="content">
      <div
        class="datum"
        [ngClass]="'width-' + datum.width"
        *ngFor="let datum of section.data"
      >
        <div class="input-container">
          <span *ngIf="datum.input" [id]="datum.label" class="input-label"
            >{{ datum.label }}
            <span class="required-asterisk" *ngIf="isFieldRequired(datum)">*</span>
          </span>
          <!-- text input -->
          <div
            class="help-container"
              *ngIf="datum.input && datum.type !== 'date' && datum.key !== '_latitude' && datum.key !== '_longitude' && datum.key !== '_pcNumberBundles' && datum.key !== '_pcTotalWeight'"
          >
            <input
              [attr.aria-label]="datum.placeholder"
              type="text"
              [name]="datum.key"
              [maxlength]="datum.maxlength"
              [placeholder]="datum.placeholder"
              [(ngModel)]="data[datum.key]"
            />
            <span
              class="help"
              [ngClass]="isHelpValid(datum)"
              *ngIf="datum.help"
              >{{ datum.help }}</span
            >
          </div>
          <div
            class="help-container"
            *ngIf="datum.input && datum.type !== 'date' && (datum.key === '_latitude' || datum.key === '_longitude')"
          >
            <input
              [attr.aria-label]="datum.placeholder"
              type="text"
              [name]="datum.key"
              (keypress)="checkLongLatChar($event)"
              [maxlength]="datum.maxlength"
              [placeholder]="datum.placeholder"
              [(ngModel)]="data[datum.key]"
            />
            <span
              class="help"
              [ngClass]="isHelpValid(datum)"
              *ngIf="datum.help"
              >{{ datum.help }}</span
            >
          </div>
          <div
            class="help-container"
              *ngIf="datum.input && (datum.key === '_pcNumberBundles' || datum.key === '_pcTotalWeight')"
          >
            <input
              [attr.aria-label]="datum.placeholder"
              type="number"
              [name]="datum.key"              
              [maxlength]="datum.maxlength"
              [placeholder]="datum.placeholder"
              [(ngModel)]="data[datum.key]"
            />
          </div>
          <!-- size class -->
          <div *ngIf="datum.sizeClass">
            <span class="input-label">Size Class: </span>
            <span>{{ getSizeClass() }}</span>
          </div>
          <!-- datepicker -->
          <input
            aria-label="Date Picker"
            type="date"
            [name]="datum.key"
            *ngIf="datum.type === 'date'"
            [(ngModel)]="data[datum.key]"
          />
          <!-- combobox -->
          <app-combobox
            *ngIf="datum.combobox"
            [(choice)]="datum.choice"
            [label]="datum.label"
            [options]="datum.options"
            key="name"
            (selectedComboboxItem)="onSelectedComboboxItem($event, datum)"
          >
          </app-combobox>
          <!-- dropdown -->
          <app-dropdown
            [(choice)]="datum.choice"
            [required]="datum.required"
            *ngIf="datum.dropdown"
            [label]="datum.label"
            [options]="datum.options"
            key="name"
            (selectedDropdownItem)="onSelectedDropdownItem($event, datum)"
          ></app-dropdown>
          <app-dropdown
            [(choice)]="datum.choice"
            *ngIf="datum.identifiers"
            [label]="datum.label"
            [options]="identifiers"
            key="name"
            (selectedDropdownItem)="onSelectedDropdownItem($event, datum)"
          ></app-dropdown>
        </div>
      </div>
    </div>
  </div>
  <!-- add jumper section -->
  <div class="section-container" *ngIf="mode === 'Update'">
    <div class="title">
      <span id="incident-jumpers">Incident Jumpers</span>
    </div>
    <!-- add incident jumper subform -->
    <div id="jumperForm" class="content incident-jumper-subform">
      <div class="fields-container">
        
          <div class="datum width-25">
            <app-dropdown
              required="true"
              [choice]="selectedBase"
              label="Base"
              [options]="bases"
              key="value"
              (selectedDropdownItem)="selectBase($event)"
            ></app-dropdown>
          </div>
          <div class="datum width-25">
            <app-combobox
              required="true"
              [choice]="selectedJumper"
              label="Jumper"
              [(options)]="activeJumpers"
              key="friendly"
              (selectedComboboxItem)="selectJumper($event)"
            ></app-combobox>
          </div>
          <div class="datum width-50">
            <div class="input-container">
              <span class="input-label">Date/Time Jumper Arrived on Incident: </span>
              <input
                aria-label="Arrival Date"
                type="date"
                [(ngModel)]="jumperArrivalDate"
                (ngModelChange)="onTimeChange($event, 'arrivalDate')"
                placeholder="Arrival Date"
              />
              <input
                style="margin-left: 20px;"
                type="time"
                aria-label="Arrival Time"
                maxlength="5"
                (ngModelChange)="onTimeChange($event, 'arrival')"
                [ngModel]="jumperArrivalTime"
                placeholder="00:00"                
              />
            </div>            
          </div>          
          <div class="datum width-50">
            <div class="input-container">
              <span class="input-label">Date/Time Jumper Departed Incident: </span>
              <input
                aria-label="Return Date"
                type="date"
                (ngModelChange)="onTimeChange($event, 'returnDate')"
                [(ngModel)]="jumperReturnDate"
                placeholder="Return Date"
              />
              <input
                style="margin-left: 20px;"
                type="time"
                aria-label="Return Time"
                maxlength="5"
                (ngModelChange)="onTimeChange($event, 'return')"
                [ngModel]="jumperReturnTime"
                placeholder="00:00"
              />
            </div>
          </div>
          <div class="datum width-50">
            <div class="input-container">
              <span class="input-label">Shifts Worked: </span>
              <input
                aria-label="Shifts Worked"
                placeholder="0"
                [(ngModel)]="totalDays"
              />
            </div>
          </div>
          <div class="datum width-50"></div>          
          <div class="datum width-33">
            <app-combobox
              [required]="areChutesRequired()"
              [choice]="selectedMainChute"
              label="Main Chute"
              [options]="mainChutes"
              key="name"
              (selectedComboboxItem)="selectMainChute($event)"
            ></app-combobox>
          </div>
          <div class="datum width-33">
            <app-combobox
              [choice]="selectedDrogueChute"
              label="Drogue Chute"
              [options]="drogueChutes"
              key="name"
              (selectedComboboxItem)="selectDrogueChute($event)"
            ></app-combobox>
          </div>
          <div class="datum width-33">
            <app-combobox
              [required]="areChutesRequired()"
              [choice]="selectedReserveChute"
              label="Reserve Chute"
              [options]="reserveChutes"
              key="name"
              (selectedComboboxItem)="selectReserveChute($event)"
            ></app-combobox>
          </div>
          <div class="datum width-33">
            <app-dropdown
              [choice]="selectedPosition1"
              label="Position 1"
              [options]="activeQualifications"
              key="name"
              (selectedDropdownItem)="selectJumperPosition($event, 1)"
            ></app-dropdown>
            <input
              aria-label="Trainee One"
              type="checkbox"              
              [(ngModel)]="T1"
            />
            <span style="font-size: 14px;" class="input-label">Trainee?</span>
          </div>
          <div class="datum width-33">
            <app-dropdown
              [choice]="selectedPosition2"
              label="Position 2"
              [options]="activeQualifications"
              key="name"
              (selectedDropdownItem)="selectJumperPosition($event, 2)"
            ></app-dropdown>
            <input
              aria-label="Trainee Two"
              type="checkbox"
              [(ngModel)]="T2"
            />
            <span style="font-size: 14px;" class="input-label">Trainee?</span>
          </div>
          <div class="datum width-33">
            <app-dropdown
              [choice]="selectedPosition3"
              label="Position 3"
              [options]="activeQualifications"
              key="name"
              (selectedDropdownItem)="selectJumperPosition($event, 3)"
            ></app-dropdown>
            <input
              aria-label="Trainee Three"
              type="checkbox"
              [(ngModel)]="T3"
            />
            <span style="font-size: 14px;" class="input-label">Trainee?</span>
          </div>          

          <div class="datum width-50">
            <app-dropdown
              [choice]="jumpRating"
              label="Jumper Rating"
              [options]="[
                {
                  name: '10',
                  value: 10
                },
                {
                  name: '9',
                  value: 9
                },
                {
                  name: '8',
                  value: 8
                },
                {
                  name: '7',
                  value: 7
                },
                {
                  name: '6',
                  value: 6
                },
                {
                  name: '5',
                  value: 5
                },
                {
                  name: '4',
                  value: 4
                },
                {
                  name: '3',
                  value: 3
                },
                {
                  name: '2',
                  value: 2
                },
                {
                  name: '1',
                  value: 1
                },
                {
                  name: '0',
                  value: 0
                }
              ]"
              key="name"
              (selectedDropdownItem)="selectJumpRating($event)"
            ></app-dropdown>
          </div>
        
      </div>
      <div class="jumper-buttons">
        <app-button
          [text]="editingJumper ? 'Update Jumper' : 'Add Jumper'"
          [disabled]="isAddJumperInvalid()"
          (clicked)="editingJumper ? updateFormJumper() : addJumper()"
          class="add-jumper-button"
        ></app-button>
        <app-button
          style="margin-left: 20px"
          *ngIf="editingJumper"
          text="Cancel"
          (clicked)="cancelJumperEdit()"
          class="add-jumper-button"
        ></app-button>
      </div>
    </div>
    <div *ngIf="incidentJumpers.length > 0" class="incident-jumpers">
      <div
        [id]="jumper.JumperId"
        class="incident-jumper"
        *ngFor="let jumper of incidentJumpers; index as i"
      >
        <div class="remove-jumper-button">
          <button style="margin-right: 10px" (click)="moveJumper('up', jumper, i)"
            >▲</button
          >
          <button
            style="margin-right: 10px"
            (click)="moveJumper('down', jumper, i)"
            >▼</button
          >
          <button style="margin-right: 10px" (click)="editJumper(jumper, i)"
            >✎</button
          >
          <button (click)="confirmDeleteJumper(jumper, i)">X</button>
        </div>
        <div class="jumper-info">
          <div>
            <span class="label">Jumper #{{ i + 1 }}: </span>
            <span class="value">{{ jumper.jumperName }}</span>
          </div>
          <div style="margin-bottom: 20px">
            <span class="label">Base: </span>
            <span class="value">{{ jumper.Base }}</span>
          </div>
          <div>
            <span class="label">Main: </span>
            <span class="value">{{ jumper.main }}</span>
          </div>
          <div>
            <span class="label">Position One:</span>
            <span class="value"> {{ jumper.position1 }}</span>
          </div>
          <div>
            <span class="label">Drogue: </span>
            <span class="value">{{ jumper.drogue }}</span>
          </div>
          <div>
            <span class="label">Position Two:</span>
            <span class="value"> {{ jumper.position2 }}</span>
          </div>
          <div style="margin-bottom: 20px">
            <span class="label">Reserve: </span>
            <span class="value">{{ jumper.reserve }}</span>
          </div>
          <div style="margin-bottom: 20px">
            <span class="label">Position Three:</span>
            <span class="value"> {{ jumper.position3 }}</span>
          </div>
          <div>
            <span class="label">Date Arrived: </span>
            <span class="value">{{ jumper.friendlyArrivalDate }}</span>
          </div>
          <div>
            <span class="label">Date Returned: </span>
            <span class="value">{{ jumper.friendlyReturnDate }}</span>
          </div>
          <div style="margin-bottom: 20px">
            <span class="label">Time Arrived: </span>
            <span class="value">{{ jumper.friendlyArrivalTime }}</span>
          </div>
          <div>
            <span class="label">Time Returned: </span>
            <span class="value">{{ jumper.friendlyReturnTime }}</span>
          </div>
          <div>
            <span class="label">Trainee One:</span>
            <span class="value"> {{ jumper.T1 ? 'Yes' : 'No' }}</span>
          </div>
          <div>
            <span class="label">Days (Shifts): </span>
            <span class="value">{{ jumper.totalDays }}</span>
          </div>
          <div>
            <span class="label">Trainee Two: </span>
            <span class="value">{{ jumper.T2 ? 'Yes' : 'No' }}</span>
          </div>
          <div>
            <span class="label">Jumper Rating: </span>
            <span class="value">{{ jumper.jumpRating }}</span>
          </div>
          <div style="margin-bottom: 20px">
            <span class="label">Trainee Three: </span>
            <span class="value">{{ jumper.T3 ? 'Yes' : 'No' }}</span>
          </div>
        </div>
      </div>
      <div class="title">
        <span>Update Jumper Date/Time</span>
      </div>
      <div class="input-container">
        <span class="input-label">Date/Time Jumper Arrived on Incident: </span>
        <input
          aria-label="Arrival Date"
          type="date"
          [(ngModel)]="jumperArrivalDate"
          (ngModelChange)="onTimeChange($event, 'arrivalDate')"
          placeholder="Arrival Date"
        />
        <input
          style="margin-left: 20px;"
          type="time"
          aria-label="Arrival Time"
          maxlength="5"
          (ngModelChange)="onTimeChange($event, 'arrival')"
          [ngModel]="jumperArrivalTime"
          placeholder="00:00"                
        />
      </div>
      <br>
      <br>
      <div class="input-container">
        <span class="input-label">Date/Time Jumper Departed Incident: </span>
        <input
          aria-label="Return Date"
          type="date"
          (ngModelChange)="onTimeChange($event, 'returnDate')"
          [(ngModel)]="jumperReturnDate"
          placeholder="Return Date"
        />
        <input
          style="margin-left: 20px;"
          type="time"
          aria-label="Return Time"
          maxlength="5"
          (ngModelChange)="onTimeChange($event, 'return')"
          [ngModel]="jumperReturnTime"
          placeholder="00:00"
        />
      </div>
      <div class="datum width-50">
        <button
        style="background-color: #006631; color: white; border-color: #006631; padding: 20px 10px; border-radius: 5px;"
        (click)="confirmCopyToAll()"
      >Update Dates & Times for all Jumpers</button>
      </div>
    </div>
  </div>
  <div class="section-container">
    <div class="title">
      <span>Notes</span>
    </div>
    <div class="content">
      <div class="datum" style="width: 100%">
        <textarea
          [(ngModel)]="data._notes"
          placeholder="Enter notes here"
        ></textarea>
      </div>
    </div>
  </div>
  <div class="section-container submit-button-container">
    <app-button
      [disabled]="isInvalid() || loading"
      [text]="mode"
      (clicked)="submitForm($event)"
      class="new-incident-button"
    ></app-button>
    <app-button
      style="margin-left: 10px"
      cancel="incidents"
      (clicked)="goToIncidents()"
      text="Cancel"
      class="cancel-button"
    >
    </app-button>
  </div>
</div>
